import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UISection from 'UIComponents/section/UISection';
import { jsx as _jsx } from "react/jsx-runtime";
export function RedAlertBanner({
  message
}) {
  return /*#__PURE__*/_jsx(UISection, {
    className: "m-top-2",
    children: /*#__PURE__*/_jsx(UIAlert, {
      type: "danger",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    })
  });
}